import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { ZeosButton } from '../../components/Shared/ZeosButton';
import { AuthContext } from '../../context/AuthContext';
import { ZeosApiContext } from '../../context/ZeosApiContext';
import { ENV } from '../../env';
import { useSignIn } from '../../hooks/useSignIn';
import { createLogger } from '../../services/Logger';
import { ONBOARDING_BASE_PATH } from '../../services/nav/Constants';
import { NavSlugType } from '../../services/nav/Types';

export const DemoStartScreen = () => {
  const log = createLogger("DemoStartScreen");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const auth = useContext(AuthContext);
  const api = useContext(ZeosApiContext);

  const autostart = searchParams.get("autostart") === "1";

  const [busy, setBusy] = useState(true);

  const { signIn } = useSignIn();

  const email = ENV.DEMO_ONBOARD_EMAIL || "";
  const password = ENV.DEMO_ONBOARD_PASSWORD || "";

  useEffect(() => {
    const initAsync = async () => {
      setBusy(true);
      await signIn({
        email,
        password,
        onSuccess: async () => {
          await api.Onboarding.demoUserDelete();
          await api.Onboarding.demoUserCreate();
          await auth.zeosUserAsync();
          setBusy(false);
        },
        onFailure: async (error) => {
          log.error("Demo auto-login failed", { error });
        },
      });
    };
    initAsync();
  }, []);

  useEffect(() => {
    const initAsync = async () => {
      if (!busy && autostart) {
        await handleStartDemo();
      }
    };
    initAsync();
  }, [busy, autostart]);

  const handleStartDemo = async () => {
    const companySlug: NavSlugType = "company";
    navigate(`${ONBOARDING_BASE_PATH}/${companySlug}`);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white shadow-md rounded-lg p-8 w-full max-w-md text-center">
        <h1 className="text-2xl font-semibold mb-4">Welcome to ZEOS</h1>
        <p className="text-gray-600 mb-8">
          {/* Start a guided demo of the onboarding experience. */}
        </p>
        <div className=" flex items-center justify-center ">
          <ZeosButton
            label={busy ? "Please wait..." : "Start Demo"}
            onPress={handleStartDemo}
            isDisabled={busy}
            type="button"
            mode="action"
          />
        </div>
      </div>
    </div>
  );
};
